<!--名单公示-->
<template>
  <div style="background: #fff;">
    <div style="position: fixed;width: 100%;z-index: 8;">
      <top-item-com active="5" :ssid="ssid"></top-item-com>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div style="margin-top:0px">
        <van-field
          left-icon="search"
          v-model="ryInfo"
          center
          clearable
          label=""
          placeholder="请输入人/队信息"
          style="position: fixed;z-index: 8;top:6rem;"
        >
          <template #button>
            <van-button size="small" type="info" @click="isksShow = true">
              <span v-for="(item, index) in wapIsks" :key="index">
                {{ item.name }}
                <span v-if="index === 0 && wapIsks.length > 1">/</span>
              </span>
            </van-button>
            &nbsp;&nbsp;
            <van-button size="small" type="primary" @click="searchHandler"
              >检 索</van-button
            >
          </template>
        </van-field>

        <!-- 统计信息卡片 -->
        <div class="stats-container">
          <div class="stats-card">
            <div class="stat-item">
              <div class="stat-label">总场数</div>
              <div class="stat-value">{{ lsData.ZCS }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">未开赛</div>
              <div class="stat-value stat-pending">{{ lsData.WKS }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">比赛中</div>
              <div class="stat-value stat-ongoing">{{ lsData.BSZ }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">已完成</div>
              <div class="stat-value stat-completed">{{ lsData.YWC }}</div>
            </div>
          </div>
        </div>

        <!-- 日期筛选器 -->
        <div class="date-filter-container" v-if="dateList.length > 0">
          <div class="date-filter-scroll">
            <!-- 全部选项 -->
            <div
              :class="[
                'date-item',
                'date-item-all',
                { active: selectedDate === '' }
              ]"
              @click="selectDate('')"
            >
              <div class="date-all-text">全部</div>
            </div>
            <!-- 日期列表 -->
            <div
              v-for="(date, index) in dateList"
              :key="index"
              :class="['date-item', { active: selectedDate === date }]"
              @click="selectDate(date)"
            >
              <div class="date-day">{{ formatDateDay(date) }}</div>
              <div class="date-month">{{ formatDateMonth(date) }}</div>
            </div>
          </div>
        </div>

        <!-- 返回顶部按钮 -->
        <div v-if="showBackTop" class="back-to-top" @click="scrollToTop">
          <van-icon name="arrow-up" size="14" />
        </div>

        <table
          class="tableClass"
          v-bind:style="{ width: tableWidth + 'px' }"
          v-if="resultList.length > 0"
        >
          <tr v-if="false">
            <td v-for="(item, index) in cdhs" :key="index">
              {{ item }}
            </td>
          </tr>
          <tr v-for="(mainItem, mainIndex) in resultList" :key="mainIndex">
            <template v-for="(cdhItem, cdhIndex) in cdhs">
              <td
                :key="cdhIndex"
                v-if="
                  (ssid ===
                    '72396d4d476e6a35306432384e69466451556a7a4f6b47476276436f44356450' &&
                    mainItem[cdhItem] !== undefined &&
                    mainItem[cdhItem] !== '无' &&
                    mainItem[cdhItem] !== '') ||
                    ssid !==
                      '72396d4d476e6a35306432384e69466451556a7a4f6b47476276436f44356450'
                "
                :colspan="
                  ssid ===
                  '72396d4d476e6a35306432384e69466451556a7a4f6b47476276436f44356450'
                    ? 3
                    : 1
                "
                style="position: relative;"
              >
                <div style="position: relative;top: 0px;">
                  <div
                    v-if="
                      mainItem[cdhItem] === undefined ||
                        mainItem[cdhItem] === '无' ||
                        mainItem[cdhItem] === ''
                    "
                  >
                    无
                  </div>

                  <div
                    v-if="
                      mainItem[cdhItem] !== undefined &&
                        mainItem[cdhItem] !== '无' &&
                        mainItem[cdhItem] !== ''
                    "
                    v-bind:style="{
                      borderRadius: '5px',
                      background:
                        mainItem[cdhItem].ISKS === '1'
                          ? '#730505'
                          : mainItem[cdhItem].ISKS === '2'
                          ? 'green'
                          : 'rgb(108, 108, 108)'
                    }"
                    @click="toSsbfIndex(mainItem[cdhItem])"
                  >
                    <div
                      v-if="
                        ISSHOWCDH === '1' &&
                          checkIsShow(mainItem[cdhItem].XJ, 'CDH')
                      "
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;background: #636363;border-top-left-radius: 5px;border-top-right-radius: 5px;"
                    >
                      {{ cdhItem }}
                    </div>
                    <div
                      v-if="
                        mainItem[cdhItem].ISKS === '1' ||
                          mainItem[cdhItem].ISKS === '2'
                      "
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                    >
                      比分：
                      {{
                        mainItem[cdhItem].ISPF1 === "1" ||
                        mainItem[cdhItem].ISDCQQ1 === "1"
                          ? "(弃)"
                          : ""
                      }}{{ mainItem[cdhItem].MARK1 }}:{{
                        mainItem[cdhItem].MARK2
                      }}{{
                        mainItem[cdhItem].ISPF2 === "1" ||
                        mainItem[cdhItem].ISDCQQ2 === "1"
                          ? "(弃)"
                          : ""
                      }}
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                    >
                      {{
                        mainItem[cdhItem].SSZL === "XH" ? "循环赛" : "淘汰赛"
                      }}/{{ mainItem[cdhItem].SSLXMC }}
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                      v-if="
                        checkIsShow(mainItem[cdhItem].XJ, 'RQ') ||
                          checkIsShow(mainItem[cdhItem].XJ, 'SJ')
                      "
                    >
                      <van-row>
                        <van-col
                          span="12"
                          v-if="checkIsShow(mainItem[cdhItem].XJ, 'RQ')"
                        >
                          <div style="text-align: left;">
                            {{
                              mainItem.RQ.length > 6
                                ? mainItem.RQ.substr(5, 9)
                                : mainItem.RQ
                            }}
                          </div>
                        </van-col>
                        <van-col
                          span="12"
                          v-if="checkIsShow(mainItem[cdhItem].XJ, 'SJ')"
                        >
                          <div style="text-align: right;">
                            {{ mainItem.STARTTIME }}
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                    <div
                      v-if="
                        checkIsShow(mainItem[cdhItem].XJ, 'XJ') ||
                          checkIsShow(mainItem[cdhItem].XJ, 'CXH')
                      "
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                    >
                      <van-row>
                        <van-col span="12">
                          <div
                            style="text-align: left;"
                            v-if="checkIsShow(mainItem[cdhItem].XJ, 'XJ')"
                          >
                            {{
                              mainItem[cdhItem] === "无"
                                ? ""
                                : "小节:" + mainItem[cdhItem].XJ
                            }}
                          </div>
                          <div v-else>
                            &nbsp;
                          </div>
                        </van-col>
                        <van-col span="12">
                          <div
                            style="text-align: right;"
                            v-if="checkIsShow(mainItem[cdhItem].XJ, 'CXH')"
                          >
                            场序:{{ mainItem.CXDZH }}
                          </div>
                          <div v-else>
                            &nbsp;
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                    >
                      <van-row>
                        <van-col span="24">
                          <div>
                            {{ mainItem[cdhItem].DZCCH }}
                            ({{
                              mainItem[cdhItem].SSZL === "TT"
                                ? mainItem[cdhItem].TITLE
                                : "第" + mainItem[cdhItem].LCH + "轮"
                            }})
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                    >
                      <van-row>
                        <van-col span="12">
                          <div style="text-align: left;">
                            {{
                              mainItem[cdhItem].SSZL === "TT"
                                ? mainItem[cdhItem].ZNWZH1
                                : mainItem[cdhItem].ZHID +
                                  "组" +
                                  mainItem[cdhItem].ZNWZH1
                            }}
                          </div>
                        </van-col>
                        <van-col span="12">
                          <div style="text-align: right;">
                            {{
                              mainItem[cdhItem].SSZL === "TT"
                                ? mainItem[cdhItem].ZNWZH2
                                : mainItem[cdhItem].ZHID +
                                  "组" +
                                  mainItem[cdhItem].ZNWZH2
                            }}
                          </div>
                        </van-col>
                      </van-row>
                    </div>

                    <div v-if="mainItem[cdhItem].SSLX.substr(1, 2) !== 'T'">
                      <div
                        style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                        v-if="
                          (mainItem[cdhItem].TEAMRYXM1 &&
                            mainItem[cdhItem].TEAMRYXM1.length > 0) ||
                            (mainItem[cdhItem].TEAMRYXM3 &&
                              mainItem[cdhItem].TEAMRYXM3.length > 0)
                        "
                      >
                        <van-row>
                          <van-col span="12">
                            <div style="text-align: left;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM1 }}
                              </span>
                            </div>
                          </van-col>
                          <van-col span="12">
                            <div style="text-align: right;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM3 }}
                              </span>
                            </div>
                          </van-col>
                        </van-row>
                      </div>
                      <div
                        style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                        v-if="
                          (mainItem[cdhItem].TEAMRYXM2 &&
                            mainItem[cdhItem].TEAMRYXM2.length > 0 &&
                            mainItem[cdhItem].TEAMRYXM2 !== '-') ||
                            (mainItem[cdhItem].TEAMRYXM4 &&
                              mainItem[cdhItem].TEAMRYXM4.length > 0 &&
                              mainItem[cdhItem].TEAMRYXM4 !== '-')
                        "
                      >
                        <van-row>
                          <van-col span="12">
                            <div style="text-align: left;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM2 }}
                              </span>
                            </div>
                          </van-col>
                          <van-col span="12">
                            <div style="text-align: right;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM4 }}
                              </span>
                            </div>
                          </van-col>
                        </van-row>
                      </div>
                      <div
                        style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                        v-if="
                          (mainItem[cdhItem].TEAMRYXM_FIN1 &&
                            mainItem[cdhItem].TEAMRYXM_FIN1.length > 0 &&
                            mainItem[cdhItem].TEAMRYXM_FIN1 !== '-') ||
                            (mainItem[cdhItem].TEAMRYXM_FIN2 &&
                              mainItem[cdhItem].TEAMRYXM_FIN2.length > 0 &&
                              mainItem[cdhItem].TEAMRYXM_FIN2 !== '-')
                        "
                      >
                        <van-row>
                          <van-col span="12">
                            <div style="text-align: left;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM_FIN1 }}
                              </span>
                            </div>
                          </van-col>
                          <van-col span="12">
                            <div style="text-align: right;">
                              <span>
                                {{ mainItem[cdhItem].TEAMRYXM_FIN2 }}
                              </span>
                            </div>
                          </van-col>
                        </van-row>
                      </div>
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                      v-if="mainItem[cdhItem].SSLX.substr(1, 2) === 'T'"
                    >
                      <van-row>
                        <van-col span="12">
                          <div style="text-align: left;">
                            <span>
                              {{ mainItem[cdhItem].RYXM1 }}
                            </span>
                          </div>
                        </van-col>
                        <van-col span="12">
                          <div style="text-align: right;">
                            <span>
                              {{ mainItem[cdhItem].RYXM2 }}
                            </span>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                    <div
                      style="margin-top:3px;color: white;padding: 3px;border-bottom: 1px solid #fff;"
                      v-if="
                        mainItem[cdhItem].SSLX.substr(1, 2) !== 'T' &&
                          (mainItem[cdhItem].DWJC1.length > 0 ||
                            mainItem[cdhItem].DWJC2.length > 0)
                      "
                    >
                      <van-row>
                        <van-col span="12">
                          <div style="text-align: left;">
                            <span
                              v-html="
                                mainItem[cdhItem].DWJC1.replace(
                                  '<span style=\'font-size: 20px;font-weight: 900;color: red;\'>',
                                  ''
                                ).replace('</span>', '')
                              "
                            ></span>
                          </div>
                        </van-col>
                        <van-col span="12">
                          <div style="text-align: right;">
                            <span
                              v-html="
                                mainItem[cdhItem].DWJC2.replace(
                                  '<span style=\'font-size: 20px;font-weight: 900;color: red;\'>',
                                  ''
                                ).replace('</span>', '')
                              "
                            ></span>
                          </div>
                        </van-col>
                      </van-row>
                    </div>
                  </div>
                </div>
              </td>
            </template>
          </tr>
        </table>

        <div style="padding-top:9.5rem" v-if="isEmpty">
          <van-empty description="未排赛或排赛中" />
        </div>
      </div>
    </van-list>

    <div style="height:30px;width:15px;"></div>

    <van-action-sheet
      v-model="isksShow"
      :actions="actions"
      @select="onSelect"
    />

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { LoadingCom, TopItemCom },
  name: "CqGsIndex",
  data() {
    return {
      ssid: "",
      resultList: [],
      tableWidth: "800",
      cdhs: [],
      ryInfo: "",
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [20, 50, 100, 1000],
        pageSize: 6, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      lsData: {
        ZCS: 0,
        BSZ: 0,
        WKS: 0,
        YWC: 0
      },
      totalCount: 0,
      isksShow: false,
      actions: [
        { name: "全部", value: "" },
        { name: "未开赛", value: "0" },
        { name: "比赛中", value: "1" },
        { name: "已结束", value: "2" }
      ],
      wapIsks: [
        { name: "未开赛", value: "0" },
        { name: "比赛中", value: "1" }
      ],
      loading: false,
      finished: false,
      isEmpty: false,
      routeValue: "",
      ISSHOWCDH: "1", //是否显示场地号
      XJKZLIST: [],
      // 日期筛选相关
      dateList: [],
      selectedDate: "",
      // 返回顶部相关
      showBackTop: false
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    this.generateDateList();
    this.mainLoadData(false);
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    checkIsShow(xj, type) {
      let XJKZLIST = this.XJKZLIST;
      if (this.XJKZLIST.length === 0) {
        return true;
      }
      let isShow = false;
      for (let i = 0; i < XJKZLIST.length; i++) {
        let dbXJ = XJKZLIST[i].XJ + "";
        let dbSHOWLX = XJKZLIST[i].SHOWLX;
        if (dbXJ === xj + "") {
          if (dbSHOWLX.length === 0) {
            isShow = true;
            break;
          } else {
            if (dbSHOWLX.indexOf(type) > -1) {
              isShow = true;
              break;
            } else {
              isShow = false;
              break;
            }
          }
        }
      }
      return isShow;
    },
    // 处理滚动事件
    handleScroll() {
      // 当滚动超过300px时显示返回顶部按钮
      this.showBackTop = window.pageYOffset > 300;
    },
    onLoad() {
      setTimeout(() => {
        this.pageSet.currentPage++;
        if (this.pageSet.currentPage > this.totalCount && this.totalCount > 0) {
          this.finished = true;
          this.loading = false;
          // alert("aa");
          return;
        }
        if (this.totalCount > 0) {
          this.mainLoadData(true);
        }
      }, 3);
      this.loading = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // 平滑滚动
      });
    },
    onTopClickLeft() {
      this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    },
    mainLoadData(isPush) {
      this.finished = false;
      this.loading = true;
      this.isEmpty = false;
      var itemWapIsks = [];
      var msg = "";
      for (var i = 0; i < this.wapIsks.length; i++) {
        if (this.wapIsks[i].name === "全部") {
        } else {
          var name = this.wapIsks[i].name;
          msg += name + ",";
          itemWapIsks.push(this.wapIsks[i].value);
        }
      }
      var busData = {
        ryInfo: this.ryInfo,
        pageSet: this.pageSet,
        wapIsks: itemWapIsks,
        selectedDate: this.selectedDate
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getJmd" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        // alert(JSON.stringify(data));
        this.loading = false;
        if (this.ryInfo.length > 0) {
          this.finished = true;
        }
        if (!data.isSuccess) {
          if (this.resultList.length === 0) {
            this.isEmpty = true;
            this.finished = true;
            this.$notify({
              type: "danger",
              message:
                msg.length === 0 ? "数据不存在" : "不存在:" + msg + "相关数据",
              duration: 3000
            });
          }
          return;
        }
        var dataCdhs = data.content[0];
        this.ISSHOWCDH = data.lsData.ISSHOWCDH;
        this.XJKZLIST = data.lsData.XJKZLIST;
        this.cdhs = [];
        for (let key in dataCdhs) {
          //console.log(key); // 输出每个键
          if (key.indexOf("第") === 0) {
            this.cdhs.push(key);
          }
        }
        this.tableWidth = this.cdhs.length * 115;
        // alert(this.cdhs);
        if (isPush) {
          this.resultList = [...this.resultList, ...data.content];
        } else {
          this.resultList = data.content;
        }
        this.lsData = data.lsData;
        this.totalCount = data.totalCount;
        // alert(data.totalCount);
        // alert(JSON.stringify(data.lsData));
      });
    },
    onDownLoad() {
      this.pageSet.currentPage++;
      if (this.pageSet.currentPage > this.totalCount) {
        this.$notify({
          type: "danger",
          message: "已到最后一页",
          duration: 3000
        });
        return;
      }
      this.mainLoadData(true);
    },
    searchHandler() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData(false);
    },
    onSelect(item) {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.wapIsks = [];
      this.wapIsks.push(item);

      this.scrollToTop();
      this.mainLoadData(false);
      this.isksShow = false;
    },
    toSsbfIndex(item) {
      this.$router.push({
        path: "/ssbfIndex",
        query: { ssid: this.ssid, jmdparam: item.CCH }
      });
    },
    // 生成日期列表（前后各7天）
    generateDateList() {
      //获取比赛日期
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getTrainDate" //对应的方法名
        },
        busData: {} //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        this.dateList = data.content;
        // 默认选中全部
        this.selectedDate = "";
      });
    },
    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // 格式化日期显示（日）
    formatDateDay(dateStr) {
      const date = new Date(dateStr);
      return String(date.getDate()).padStart(2, "0");
    },
    // 格式化日期显示（月-日）
    formatDateMonth(dateStr) {
      const date = new Date(dateStr);
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${month}-${day}`;
    },
    // 选择日期
    selectDate(date) {
      this.selectedDate = date;
      // 重新加载数据
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData(false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.tableClass {
  background: #fff;
  border-collapse: collapse;
}
.tableClass td {
  width: 115px;
  text-align: center;
  border: 1px solid #ddd;
  padding-top: 3px;
  padding-left: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  font-size: 13px;
}

/* 统计信息卡片样式 */
.stats-container {
  background: #fff;
  padding: 12px 10px;
  padding-top: 9.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.stats-card {
  display: flex;
  justify-content: space-around;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-radius: 8px;
  padding: 12px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.stat-item {
  flex: 1;
  text-align: center;
  position: relative;
}

.stat-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: linear-gradient(to bottom, transparent, #e0e0e0, transparent);
}

.stat-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.stat-pending {
  color: #ff9800;
}

.stat-ongoing {
  color: #1989fa;
}

.stat-completed {
  color: #07c160;
}

/* 日期筛选器样式 */
.date-filter-container {
  background: #fff;
  padding: 6px 0;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.date-filter-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 6px;
  gap: 4px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.date-filter-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.date-item {
  flex-shrink: 0;
  min-width: 40px;
  padding: 4px 6px;
  background: #f5f5f5;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
}

.date-item:active {
  transform: scale(0.95);
}

.date-item.active {
  background: linear-gradient(135deg, #1989fa 0%, #1677d9 100%);
  border-color: #1989fa;
  box-shadow: 0 2px 6px rgba(25, 137, 250, 0.3);
}

.date-day {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  margin-bottom: 1px;
}

.date-item.active .date-day {
  color: #fff;
}

.date-month {
  font-size: 9px;
  color: #999;
  line-height: 1;
}

.date-item.active .date-month {
  color: rgba(255, 255, 255, 0.9);
}

/* 全部选项样式 */
.date-item-all {
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.date-all-text {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.date-item-all.active .date-all-text {
  color: #fff;
}

/* 返回顶部按钮样式 */
.back-to-top {
  position: fixed;
  right: 12px;
  bottom: 25px;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #1989fa 0%, #1677d9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(25, 137, 250, 0.35);
  z-index: 999;
  transition: all 0.3s ease;
  animation: fadeInUp 0.3s ease;
}

.back-to-top:active {
  transform: scale(0.9);
}

.back-to-top .van-icon {
  color: #fff;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JmdIndex/JmdIndex.vue